/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { message } from "antd";
import { logout } from "../services/authService";
import { fetchUserById } from "../services/userService";
import { jwtDecode } from "jwt-decode";

// ✅ Import icons properly
import {
  blog,
  dashboard,
  logout01,
  menuicon06,
  doctorschedule,
  menuicon09,
} from "./imagepath";

const Sidebar = (props) => {
  const [loggedInUserData, setLoggedInUserData] = useState(null);
  const [sidebar, setSidebar] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleClick = (e, item, item1) => {
    const div = document.querySelector(`#${item}`);
    const ulDiv = document.querySelector(`.${item1}`);
    if (!div || !ulDiv) return;

    const isActive = ulDiv.style.display === "block";
    ulDiv.style.display = isActive ? "none" : "block";
    div.classList.toggle("subdrop", !isActive);
  };

  useEffect(() => {
    if (props?.id && props?.id1) {
      const ele = document.getElementById(`${props?.id}`);
      handleClick(ele, props?.id, props?.id1);
    }
  }, []);

  useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = await fetchUserById(decoded.id);
          setLoggedInUserData(user);
        } catch (error) {
          console.error("Error decoding token or fetching user:", error);
          localStorage.removeItem("token");
          setLoggedInUserData(null);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchAndSetUser();
  }, []);

  const expandMenu = () => document.body.classList.remove("expand-menu");
  const expandMenuOpen = () => document.body.classList.add("expand-menu");

  // ✅ Best logout logic — ensures UI + context reset immediately
  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        await logout(token);
      }

      message.success("Logged out successfully");

      // Step 1: Clear local/session storage
      localStorage.clear();
      sessionStorage.clear();

      // Step 3: Hard reload to reset React state and show login
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      message.warning("Error during logout, please try again");

      // fallback
      localStorage.clear();
      navigate("/login");
    }
  };

  return (
    <div className="sidebar" id="sidebar">
      <Scrollbars
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        autoHeight
        autoHeightMin={0}
        autoHeightMax="95vh"
        thumbMinSize={30}
        hideTracksWhenNotNeeded
      >
        <div
          id="sidebar-menu"
          className="sidebar-menu"
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          {/* ✅ Render only if loggedInUserData is present */}
          {loggedInUserData ? (
            <ul>
              <li className="menu-title">Main</li>

              {/* Users Menu */}
              {(loggedInUserData?.user_role === "1" ||
                loggedInUserData?.user_role === "2") && (
                <li className="submenu">
                  <Link
                    to="#"
                    id="menu-item"
                    onClick={(e) => handleClick(e, "menu-item", "menu-items")}
                  >
                    <span className="menu-side">
                      <img src={dashboard} alt="Users" />
                    </span>
                    <span>Users</span> <span className="menu-arrow" />
                  </Link>
                  <ul
                    style={{
                      display: sidebar === "Dashboard" ? "block" : "none",
                    }}
                    className="menu-items"
                  >
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "home" ? "active" : ""
                        }
                        to="/list-users"
                      >
                        List Users
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "staff-list"
                            ? "active"
                            : ""
                        }
                        to="/add-users"
                      >
                        Add Users
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* Departments */}
              {loggedInUserData?.user_role === "1" && (
                <li>
                  <Link
                    className={
                      props?.activeClassName === "list-departments"
                        ? "active"
                        : ""
                    }
                    to="/list-department"
                  >
                    <span className="menu-side">
                      <img src={menuicon06} alt="Departments" />
                    </span>
                    <span>Departments</span>
                  </Link>
                </li>
              )}

              {/* Carousel */}
              {loggedInUserData?.user_role === "1" && (
                <li className="submenu">
                  <Link
                    to="#"
                    id="menu-item5"
                    onClick={(e) => handleClick(e, "menu-item5", "menu-items5")}
                  >
                    <span className="menu-side">
                      <img src={doctorschedule} alt="Carousel" />
                    </span>
                    <span>Carousel</span> <span className="menu-arrow" />
                  </Link>
                  <ul style={{ display: "none" }} className="menu-items5">
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "list-carousel"
                            ? "active"
                            : ""
                        }
                        to="/list-carousel"
                      >
                        List Carousel
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "add-carousel"
                            ? "active"
                            : ""
                        }
                        to="/add-carousel"
                      >
                        Add Carousel
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* Blogs */}
              <li className="submenu">
                <Link
                  to="#"
                  id="menu-item-blog"
                  onClick={(e) =>
                    handleClick(e, "menu-item-blog", "menu-items-blog")
                  }
                >
                  <span className="menu-side">
                    <img src={blog} alt="Blogs" />
                  </span>
                  <span>Blogs</span> <span className="menu-arrow" />
                </Link>
                <ul style={{ display: "none" }} className="menu-items-blog">
                  <li>
                    <Link
                      className={
                        props?.activeClassName === "blog-list" ? "active" : ""
                      }
                      to="/blogs"
                    >
                      List Blogs
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        props?.activeClassName === "add-blog" ? "active" : ""
                      }
                      to="/add-blog"
                    >
                      Add Blog
                    </Link>
                  </li>

                  {loggedInUserData && loggedInUserData?.user_role != null && (
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "blog-approval"
                            ? "active"
                            : ""
                        }
                        to="/blog-approval"
                      >
                        Approve Blogs
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              {/* Events */}
              {loggedInUserData?.user_role === "1" && (
                <li className="submenu">
                  <Link
                    to="#"
                    id="menu-item6"
                    onClick={(e) => handleClick(e, "menu-item6", "menu-items6")}
                  >
                    <span className="menu-side">
                      <img src={menuicon06} alt="Events" />
                    </span>
                    <span>Events</span> <span className="menu-arrow" />
                  </Link>
                  <ul style={{ display: "none" }} className="menu-items6">
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "list-events"
                            ? "active"
                            : ""
                        }
                        to="/list-events"
                      >
                        List Events
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "add-event" ? "active" : ""
                        }
                        to="/add-event"
                      >
                        Add Event
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              
              {/* Activities */}
              
              {loggedInUserData?.user_role != null && (
                <li className="submenu">
                  <Link
                    to="#"
                    id="menu-item-activity"
                    onClick={(e) =>
                      handleClick(
                        e,
                        "menu-item-activity",
                        "menu-items-activities"
                      )
                    }
                  >
                    <span className="menu-side">
                      <img src={menuicon06} alt="Activities" />
                    </span>
                    <span>Activities</span> <span className="menu-arrow" />
                  </Link>
                  <ul
                    style={{ display: "none" }}
                    className="menu-items-activities"
                  >
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "list-activities"
                            ? "active"
                            : ""
                        }
                        to="/list-activities"
                      >
                        List Activities
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "add-activity"
                            ? "active"
                            : ""
                        }
                        to="/add-activity"
                      >
                        Add Activity
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* News */}
              {loggedInUserData?.user_role === "1" && (
                <li className="submenu">
                  <Link
                    to="#"
                    id="menu-item-news"
                    onClick={(e) =>
                      handleClick(e, "menu-item-news", "menu-items-news")
                    }
                  >
                    <span className="menu-side">
                      <img src={menuicon09} alt="News" />
                    </span>
                    <span>News</span> <span className="menu-arrow" />
                  </Link>
                  <ul style={{ display: "none" }} className="menu-items-news">
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "list-news" ? "active" : ""
                        }
                        to="/list-news"
                      >
                        List News
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "add-news" ? "active" : ""
                        }
                        to="/add-news"
                      >
                        Add News
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* Notification */}
              {loggedInUserData?.user_role === "1" && (
                <li className="submenu">
                  <Link
                    to="#"
                    id="menu-item-notification"
                    onClick={(e) =>
                      handleClick(
                        e,
                        "menu-item-notification",
                        "menu-items-notification"
                      )
                    }
                  >
                    <span className="menu-side">
                      <i className="fa-duotone fa-bell" />
                    </span>
                    <span>Notification</span> <span className="menu-arrow" />
                  </Link>
                  <ul
                    style={{ display: "none" }}
                    className="menu-items-notification"
                  >
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "popup" ? "active" : ""
                        }
                        to="/notification/popup"
                      >
                        Popup
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          props?.activeClassName === "marquee" ? "active" : ""
                        }
                        to="/notification/marquee"
                      >
                        Marquee
                      </Link>
                    </li>
                  </ul>
                </li>
              )}

              {/* Gallery */}
              {loggedInUserData?.user_role === "1" && (
                <li>
                  <Link
                    className={
                      props?.activeClassName === "gallery" ? "active" : ""
                    }
                    to="/gallery"
                  >
                    <i className="fa-duotone fa-folder-image"></i>
                    <span>Gallery</span>
                  </Link>
                </li>
              )}

              {/* File Manager */}
              {loggedInUserData?.user_role === "1" && (
                <li>
                  <Link
                    className={
                      props?.activeClassName === "file-manager" ? "active" : ""
                    }
                    to="/file-manager"
                  >
                    <i className="fa-duotone fa-folder-open"></i>
                    <span>File Manager</span>
                  </Link>
                </li>
              )}

              {/* Logs */}
              {loggedInUserData?.user_role === "1" && (
                <li>
                  <Link
                    className={
                      props?.activeClassName === "logs" ? "active" : ""
                    }
                    to="/logs"
                  >
                    <i className="fa-duotone fa-seal-question"></i>
                    <span>Logs</span>
                  </Link>
                </li>
              )}
            </ul>
          ) : null}

          {/* Logout Button */}
          <div className="logout-btn">
            <Link to="#" onClick={handleLogout}>
              <span className="menu-side">
                <img src={logout01} alt="Logout" />
              </span>
              <span>Logout</span>
            </Link>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
};

export default Sidebar;
